import { RootScopeEvents } from 'common/services/root-scope-types';
import { ErrorTrack } from '../error.track';
export default class PublisherMediaBroken extends ErrorTrack {
    constructor() {
        super(...arguments);
        this.errorType = 'Publisher Media Broken';
    }
    start() {
        this.$rootScope.$on(RootScopeEvents.MEDIA_BROKEN, (_e, data) => {
            this.trackSegment({
                errorSubtype: data.mediaIssueType,
                errorType: this.errorType,
                mediaIssues: data.mediaIssues,
            });
        });
    }
}
